import { FC } from "react";
import { Outlet } from "react-router-dom";

const UnauthenticatedLayout: FC = () => {
  return <Outlet />;
};

export default UnauthenticatedLayout;
